jQuery(function ($) {
  $(document).ready(function () {
    // $("#cartform #note").val("");
    // $("#custom-note").val("");

    // show/hide datepicker
    var datePickerLoaded = false; // prevent load multi time
    // Create a MutationObserver instance with a callback function.
      var observer = new MutationObserver(function(mutations, observerInstance) {
        // Check if the target element exists
        var datePickerWrap = $('form#cartform #order-slots-option');
        if (datePickerWrap.length && !window.datePickerLoaded) {
          window.datePickerLoaded = true;
          
          // Execute your logic based on the condition.
          if (window.noDelivery) {
            setTimeout(function () {
              $('#standard-shipping-option-div').click();
            }, 1000);
          } else {
            setTimeout(function () {
              // Ensure you use the correct selector (e.g., add '#' if it's an ID)
              $('#delivery-pickup-option-div').click();
            }, 1000);
          }
          
          // Once we've detected and handled the insertion, stop the observer.
          observerInstance.disconnect();
        }
      });
    
      // Configuration to observe child additions anywhere in the body (or a narrower container if you prefer)
      var config = { childList: true, subtree: true };
      
      // Start observing - you can narrow the target from document.body to a more specific container if needed.
      observer.observe(document.body, config);

    // validate checkout button
    if (!window.noDelivery) {
      // using the interval to check condition
      setInterval(function() {
        if ($(".checkout-button").attr("disabled") === undefined) {
          if($(".neo-input") && !$(".neo-input").val()) {
            $(".checkout-button").attr("disabled", true);
          }
        }
      },100);

      $(document).on("click", ".neo-slot-picker", function () {
        setTimeout(function () {
          $(".neo-input").change();
        }, 200);
      });

      $(document).on("change", ".neo-input", function () {
        // updateNote()
        if (!$(this).val()) {
          // canCheckout = false;
          $(".checkout-button").attr("disabled", true);
        } else {
          // canCheckout = true;
          $(".checkout-button").removeAttr("disabled");
        }
      });

      // $(document).on("change", "#custom-note", function () {
      //   updateNote()
      // });
    }
  });

  // function updateNote() {
  //   $("#cartform #note").val("");
  //   const customerNote = "** Customer Note: " + $("#custom-note").val() ?? "";
  //   const deliveryNote = "** Delivery Date: " + $("#cartform .neo-input").val() ?? "";
  //   $("#cartform #note").val(
  //     customerNote + "\n" + deliveryNote
  //   );
  // }
});
